import random from 'lodash/random';
import React, { Component } from 'react';
import SpringScrollbars from './SpringScrollbars';
import Lightbox from 'react-image-lightbox';
import ReactImageFallbackRb from "react-image-fallback-rb";
import store from './../store';

export default class ScrollList extends Component {

    constructor(props) {
        super(props);

        this.state = {
            photoIndex: 0,
            isOpen: false,
            imgCol: 0,
            viewport: {
                width: document.documentElement.clientWidth,
                height: document.documentElement.clientHeight
            },
            breakpoint:747,
            transform:1
        };
        this.handleClickRandomPosition = this.handleClickRandomPosition.bind(this);
        this.handleClickTopPosition = this.handleClickTopPosition.bind(this);
        this.handleClickMobile = this.handleClickMobile.bind(this);
        this.handlenScrollStop = this.handlenScrollStop.bind(this);
    //    this.handleWindowWheel = this.handleWindowWheel.bind(this);
        this.closeOverlay = this.closeOverlay.bind(this);
        this.handleResize = this.handleResize.bind(this);
        this.genGrey = this.genGrey.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
    }

    componentDidMount() {
      window.addEventListener("resize", this.handleResize, false);
      window.addEventListener('scroll', this.handleScroll,false);

      this.setState({
            viewport: {
                width: document.documentElement.clientWidth,
                height: document.documentElement.clientHeight
            }
        });

    //window.addEventListener("mousewheel", this.handleWindowWheel, false);
    if(this.state.viewport.width > this.state.breakpoint){
    const { scrollbars } = this.refs;
    scrollbars.scrollTop(0);
    var prp = this.props.initialScroll;
    var t = setTimeout(function(){ scrollbars.scrollTop(prp); clearTimeout(t);},2000);
    }
  }

  handleScroll(event) {
    let scrollTop = event.srcElement.body.scrollTop || event.target.body.scrollTop,
        itemTranslate = Math.min(scrollTop);
        ////console.log('itemTranslate: ' + itemTranslate);

    if(itemTranslate == 0 ){
    this.setState({
      transform: itemTranslate
    });

      const { scrollbars } = this.refs;
      if(scrollbars){
      var prp = this.props.initialScroll;
      var t = setTimeout(function(){ scrollbars.scrollTop(0); clearTimeout(t);},300);
      }
    }else{
      return false;
    }
}

  handleResize(e) {
    this.setState({
          viewport: {
              width: document.documentElement.clientWidth,
              height: document.documentElement.clientHeight
          }
      });
  }

  /* handleWindowWheel(event) {
    const { top } = this.refs.scrollbars.getValues();
    // When the bottom is reached and we're scrolling down, prevent scrolling of the window
    if (top >= 1 && event.deltaY > 0) event.preventDefault();
    ////console.log(top);
  } */

  closeOverlay() {
    this.setState({ isOpen: false, photoIndex:0 });

    ////console.log( 's2: ' + this.state.scrollPos);

    if(this.state.viewport.width > this.state.breakpoint){
    var t1 = setTimeout(()=>{
      const { scrollbars } = this.refs;
      scrollbars.scrollTop(this.state.scrollPos);
    },800);
  }
  }

    handleClickRandomPosition() {
        const { scrollbars } = this.refs;
        const scrollHeight = scrollbars.getScrollHeight();
        scrollbars.scrollTop(random(scrollHeight));
        //console.log('scrolled!!!');

    }

    handlenScrollStop(){
      const { scrollTop } = this.refs.scrollbars.getValues();
      //console.log('s: ' + scrollTop );
      //this.setState( { scrollPos: top } );
    }


    handleClickTopPosition(i,tgl,pos) {
        const { scrollbars } = this.refs;
        const { scrollTop } = scrollbars.getValues();

        this.setState({ scrollPos: scrollTop, imageCol: i, photoIndex: pos });


        scrollbars.scrollTop(0);
        //console.log('scrolled to top from' + scrollTop);

        if(tgl != 'modal'){ //we open the component modal, not the page modal
        var t = setTimeout(
          ()=>{
            this.setState({ isOpen: true });
            clearTimeout(t);

          }
          ,800);
        }

    }
    handleClickMobile(i,tgl,pos) {
        this.setState({ imageCol: i, photoIndex: pos });
          if(tgl != 'modal'){
        var t = setTimeout(
          ()=>{
            this.setState({ isOpen: true });
            clearTimeout(t);

          }
          ,100);
        }

    }

    genGrey() {
      var value = Math.random() * 0xFF | 0;
      var grayscale = (value << 16) | (value << 8) | value;

      return '#' + grayscale.toString(16);
    }

    genThumbs() {

      var $out= [];

      for (var i = 0; i < this.props.arr.length ; i++){

        var tgl = this.props.arr[i][0].tgl;
        var pos = this.props.arr[i][0].pos;
      $out.push(
        <a className="thumbnailInList"
            style={ {background: this.genGrey()} }
            href={this.props.arr[i][0].dest}
            onClick= {this.handleClickTopPosition.bind(null, i, tgl, pos)}
            key={'gall'+i}
            data-id={'g_' + i}
            data-toggle={tgl}
            >
              <div className="portfolio-hover">
              <div className="portfolio-hover-content">
                <p>{this.props.arr[i][0].ttl}<br/>
                {this.props.arr[i][0].client}</p>
                <p>{this.props.arr[i][0].des}</p>
                <i className="fa fa-plus fa-2x"></i>
              </div>
            </div>
              <ReactImageFallbackRb
                     fallbackImage='/public/images/trans.gif'
                     src={'http:' + this.props.arr[i][0].thumb}
                     alt={ 'image '+i }
                     className='thumbs'
                      />
        </a>
          );

      }
      return $out;
    }



    genThumbsMobile() {

      var $out= [];
      for (var i = 0; i < this.props.arr.length ; i++){
        var tgl = this.props.arr[i][0].tgl;
        var pos = this.props.arr[i][0].pos;
      $out.push(
        <a className="thumbnailInList"
            style={ {background: this.genGrey(), width:this.state.viewport.width +'px'} }
            href={this.props.arr[i][0].dest}
            onClick= {this.handleClickMobile.bind(null, i, tgl, pos)}
            key={'gall'+i}
            data-id={'g_' + i}
            data-toggle={tgl}
            >
              <div className="portfolio-hover">
              <div className="portfolio-hover-content">
                <p>{this.props.arr[i][0].ttl}<br/>
                {this.props.arr[i][0].client}</p>
                <p>{this.props.arr[i][0].des}</p>
                <i className="fa fa-plus fa-2x"></i>
              </div>
            </div>
              <ReactImageFallbackRb
                fallbackImage='/public/images/trans.gif'
					           src={'http:' + this.props.arr[i][0].thumb}
					           alt={ 'image '+i }
					           className='thumbs' />

            </a>
          );

      }
      return $out;
    }


    render() {


      const {
          imageCol,
          photoIndex,
          isOpen,
          breakpoint,
          viewport,
      } = this.state;

      const images = this.props.arr[imageCol];
      const _h = viewport.width > breakpoint ? viewport.width/4 : viewport.width*4;//viewport.height < 900 ? 500 : viewport.height-200;

      const gStyle={
  overlay : {
  position          : 'fixed',
  top               : 0,
  left              : 0,
  right             : 0,
  bottom            : 0,
  overflow          : 'hidden',
  backgroundColor   : 'rgba(255, 255, 255, 1)'
  },
  content : {
  position                   : 'absolute',
  top                        : '0px',
  left                       : '0px',
  right                      : '0px',
  bottom                     : '0px',
  border                     : '0px solid #ccc',
  background                 : '#fff',
  overflow                   : 'hidden',
  WebkitOverflowScrolling    : 'touch',
  borderRadius               : '0px',
  outline                    : 'none',
  padding                    : '0px',
  backgroundColor   : 'rgba(255, 255, 255, 1)'

  }
  };


        return (
            <div className={this.props.className}>

              {viewport.width > breakpoint &&
                <SpringScrollbars
                    data-wW ={this.props.wW}
                    data-title={this.props.title}
                    ref="scrollbars"
                    style={{ height: _h, width:100+'%' }}
                    //onScrollStop={this.handlenScrollStop}
                    >



                      {this.genThumbs()}

                    {isOpen &&
                        <Lightbox
                            mainSrc={images[photoIndex].url}
                            nextSrc={images[(photoIndex + 1) % images.length].url}
                            prevSrc={images[(photoIndex + images.length - 1) % images.length].url}
                            imageCaption={images[photoIndex].ttl + ' / ' +images[photoIndex].client + ' / ' +images[photoIndex].des + ' / ' + images[photoIndex].cat}
                            reactModalStyle={gStyle}
                            enableZoom={false}

                            onCloseRequest={this.closeOverlay}
                            onMovePrevRequest={() => this.setState({
                                photoIndex: (photoIndex + images.length - 1) % images.length,
                            })}
                            onMoveNextRequest={() => this.setState({
                                photoIndex: (photoIndex + 1) % images.length,
                            })}
                        />
                    }


                </SpringScrollbars>
              }
              { viewport.width <= breakpoint &&
              <div>  {this.genThumbsMobile()}
                {isOpen &&
                    <Lightbox
                        mainSrc={images[photoIndex].url}
                        nextSrc={images[(photoIndex + 1) % images.length].url}
                        prevSrc={images[(photoIndex + images.length - 1) % images.length].url}
                        imageCaption={images[photoIndex].ttl + ' / ' +images[photoIndex].client + ' / ' +images[photoIndex].des + ' / ' + images[photoIndex].cat}
                        reactModalStyle={gStyle}
                        enableZoom={false}

                        onCloseRequest={this.closeOverlay}
                        onMovePrevRequest={() => this.setState({
                            photoIndex: (photoIndex + images.length - 1) % images.length,
                        })}
                        onMoveNextRequest={() => this.setState({
                            photoIndex: (photoIndex + 1) % images.length,
                        })}
                    />
                }

              </div>
              }

            </div>


        );
    }
}



// WEBPACK FOOTER //
// ./src/js/components/ScrollList.js